import { render, staticRenderFns } from "./system-footer.vue?vue&type=template&id=1d3f51d6&scoped=true&"
import script from "./system-footer.vue?vue&type=script&lang=js&"
export * from "./system-footer.vue?vue&type=script&lang=js&"
import style0 from "./system-footer.vue?vue&type=style&index=0&id=1d3f51d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3f51d6",
  null
  
)

export default component.exports